import React from "react";
import {ArrowUpRight, ArrowDownRight, Minus} from "lucide-react";
import {useTranslation} from "react-i18next";
import {computeDelta} from "../comparison";

/**
 * Shows how a KPI moved against the comparison period: "▲ 12,5 %" plus the
 * previous value ("vs 1 234,00 DH"). `invert` flips the colours for metrics
 * where a rise is bad (e.g. total discounts).
 */
const DeltaBadge = ({current, previous, formatValue, invert = false, isDarkMode = false, align = "center"}) => {
    const {t} = useTranslation("activite");
    const delta = computeDelta(current, previous);
    const hasPrevious = previous !== null && previous !== undefined && previous !== "";

    if (!hasPrevious) return null;

    let tone = isDarkMode ? "text-gray-400" : "text-gray-500";
    let Icon = Minus;
    if (delta !== null && Math.abs(delta) >= 0.05) {
        const isGood = invert ? delta < 0 : delta > 0;
        tone = isGood
            ? (isDarkMode ? "text-emerald-400" : "text-emerald-600")
            : (isDarkMode ? "text-red-400" : "text-red-500");
        Icon = delta > 0 ? ArrowUpRight : ArrowDownRight;
    }

    const deltaText = delta === null
        ? "—"
        : `${delta > 0 ? "+" : ""}${delta.toLocaleString("fr-FR", {maximumFractionDigits: 1})} %`;

    return (
        <div
            data-testid="delta-badge"
            className={`mt-1 flex flex-wrap items-center gap-x-1.5 text-xs ${
                align === "start" ? "justify-start" : "justify-center"
            }`}
        >
            <span className={`inline-flex items-center gap-0.5 font-semibold ${tone}`}>
                <Icon className="h-3.5 w-3.5" strokeWidth={2.5}/>
                {deltaText}
            </span>
            <span className={isDarkMode ? "text-gray-500" : "text-gray-400"}>
                {t("comparison.vs")} {formatValue ? formatValue(previous) : previous}
            </span>
        </div>
    );
};

export default DeltaBadge;
